import React, { useEffect, useState } from "react";

/**
 *
 * @param {number} [delay=1000]
 * @param {object} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function Expire({ delay = 1000, ...props }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let timer;
    const setTimer = () => {
      if (!!timer) clearTimeout(timer);

      timer = setTimeout(() => {
        setVisible(false);
        timer = null;
      }, delay);
    };

    setTimer();

    return () => {
      clearTimeout(timer);
    };
  }, [delay]);

  return visible ? <span>{props.children}</span> : <span />;
}
